import { NodeEnvironment } from '.';

export const REACT_APP_API_BASE_URL =
  process.env.NODE_ENV === NodeEnvironment.DEV
    ? 'https://rr8qsmkmc1.execute-api.us-east-1.amazonaws.com/hs-test'
    : 'https://api.thomasschultzpianist.com';
